import { supabase } from '@/integrations/supabase/client';

export type PublicTrackingAction =
  | 'whatsapp_click'
  | 'contact_click'
  | 'investor_click';

interface TrackOptions {
  action: PublicTrackingAction;
  language?: string;
  source?: string; // e.g. "header", "hero", "footer"
  extra?: Record<string, unknown>;
}

/**
 * Fire-and-forget public-site click tracking. Writes to public.audit_logs
 * under entity = 'public_site'. Allowed actions are gated by RLS.
 */
export function trackPublicClick({ action, language, source, extra }: TrackOptions) {
  try {
    supabase
      .from('audit_logs')
      .insert({
        action,
        entity: 'public_site',
        new_data: {
          language: language ?? null,
          source: source ?? null,
          path: typeof window !== 'undefined' ? window.location.pathname : null,
          referrer: typeof document !== 'undefined' ? document.referrer || null : null,
          user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
          timestamp: new Date().toISOString(),
          ...(extra || {}),
        },
      })
      .then(({ error }) => {
        if (error) console.warn(`Public click log failed (${action}):`, error.message);
      });
  } catch (err) {
    console.warn('trackPublicClick error:', err);
  }
}
